import actionTypes from '../constants/action-types';

const buildSlug = (state = null, action) => {
  if (action.type !== actionTypes.SET_TEMPLATE_BUILD_SLUG) return state;
  return action.payload.templateBuildSlug;
};

export default buildSlug;
